import { render, staticRenderFns } from "./CustomerAutocomplete.vue?vue&type=template&id=789e9f34"
import script from "./CustomerAutocomplete.vue?vue&type=script&lang=ts"
export * from "./CustomerAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports